<template>
  <div class="reg-row">
    <div>
      <p class="reg-row-name">
        {{ name }}
      </p>
      <p v-if="metaLine" class="reg-row-meta">
        {{ metaLine }}
      </p>
    </div>
    <div class="flex-shrink-0" v-if="paymentsActive">
      <template v-if="hasAlert">
        <swal-alert
            :url="url"
            :title="alertProperty('title')"
            :description="alertProperty('description')"
            :confirm-text="alertProperty('confirmText')"
        >
          <a :href="url" class="reg-brand-btn">Sign up</a>
        </swal-alert>
      </template>
      <template v-else>
        <a :href="url" class="reg-brand-btn">Sign up</a>
      </template>
    </div>
  </div>
</template>
<script>
import SwalAlert from '../../shared/swal_alert.vue';

export default {
  name: 'sign-up-row',
  components: { SwalAlert },
  props: {
    name: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    start: {
      type: String,
      required: false,
    },
    end: {
      type: String,
      required: false,
    },
    sessionType: {
      type: String,
      required: true,
    },
    swalAlert: {
      type: Object,
      required: false,
      default() { return {}; },
    },
    paymentsActive: {
      type: Boolean,
      required: false,
      default: true,
    },
    locationName: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    hasAlert() {
      return this.swalAlert?.title && this.swalAlert?.description && this.swalAlert?.confirmText;
    },
    hasDates() {
      return this.start && this.end;
    },
    metaLine() {
      const parts = [];
      if (this.hasDates) {
        parts.push(this.dateRange());
      }
      if (this.locationName) {
        parts.push(this.locationName);
      }
      return parts.join(' · ');
    },
  },
  methods: {
    alertProperty(key) {
      return _.get(this.swalAlert, key, '');
    },
    dateRange() {
      const start = moment(this.start).format('MMM Do YYYY');
      const end = moment(this.end).format('MMM Do YYYY');
      return `${start} to ${end}`;
    },
  },
};
</script>
<style scoped>
</style>
